import { Deserializable } from '../protocols/deserializable';
import { BaseType } from '../base/base-type';
import { AnnuityGuaranteeTypeIdEnum } from '../enum/shared/annuity-guarantee-type-id.enum';

export class AnnuityGuaranteePeriodType extends BaseType implements Deserializable {
  public declare id: AnnuityGuaranteeTypeIdEnum;
  public value!: number;
  public archived!: boolean;

  public onDeserialize(): void {}
}
